interface Input {
  url_parameters: Object;
  body: Object;
}

interface Output<T> {
  num_records: Number;
  data: T;
  messages: string[];
  time_stamp: string;
}

export interface ApiResponse<T> {
  input: Input;
  output: Output<T>;
}

export interface ApiErrorResponse {
  errorType: string;
  message: string; // user-friendly message
  details?: string; // developer debug details
}

/**
 * Custom error codes set by backend.
 *
 */
export enum ErrorStatusCodes {
  BaseVizError = 550,
  GHCError = 551,
  PEAError = 552,
  MLFError = 553,
}
